import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { LoadingPanel } from "../../LoadingPanel";
import { addNotificationWithTimeout } from '../../../app/addNotificationWithTimeout';
import { handleResponse } from '../../../app/handleResponse';
import { getCSRFToken } from '../../../app/getCSRFToken';
import {
    Grid,
    GridColumn as Column,
} from "@progress/kendo-react-grid";
import { Button } from "@progress/kendo-react-buttons";
import { Checkbox } from "@progress/kendo-react-inputs";

export const AdministratorMyShortedEventsWithWrongOnHandDate = () => {
    const dispatch = useDispatch();

    const [myShortedEventsWithWrongOnHandDate, setMyShortedEventsWithWrongOnHandDate] = useState(undefined);
    const [isLoading, setIsLoading] = useState(false);
    const [totalEventCount, setTotalEventCount] = useState(0);
    const [isHeaderCheckboxChecked, setIsHeaderCheckboxChecked] = useState(false);
    const [lastSelectedTicketGroupId, setLastSelectedTicketGroupId] = useState(undefined);

    const initialPageState = {
        skip: 0,
        take: 50,
    };
    const [page, setPage] = useState(initialPageState);
    const pageChange = (event) => {
        setPage(event.page);
    };

    const getMyShortedEventsWithWrongOnHandDate = () => {
        setIsLoading(true);

        const dataItem = {

        };

        fetch(`/api/administrator/pos/myshortedeventswithwrongonhanddate`,
            {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    "X-XSRF-TOKEN": getCSRFToken(),
                },
                body: JSON.stringify(dataItem),
            })
            .then(handleResponse)
            .then(result => {
                setPage(initialPageState);
                setMyShortedEventsWithWrongOnHandDate(result);
                setTotalEventCount(result.length);
                setIsHeaderCheckboxChecked(false);
                setLastSelectedTicketGroupId(undefined);
            })
            .catch(error => {
                addNotificationWithTimeout(dispatch, "error", error.message);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }

    const updateTicketGroupsOnHandDate = (ticketGroups) => {
        if (window.confirm("Are you sure you want to update the on hand date for these ticket groups?") === false) {
            return;
        }

        setIsLoading(true);

        const dataItem = {
            ticketGroups: ticketGroups,
        };

        fetch(`/api/administrator/pos/markticketgroupsasnotonhand`,
            {
                method: "PUT",
                headers: {
                    'Content-Type': 'application/json',
                    "X-XSRF-TOKEN": getCSRFToken(),
                },
                body: JSON.stringify(dataItem),
            })
            .then(handleResponse)
            .then(result => {
                addNotificationWithTimeout(dispatch, "success", "Updated ticket groups on hand date successfully");

                setPage(initialPageState);
                getMyShortedEventsWithWrongOnHandDate();
            })
            .catch(error => {
                addNotificationWithTimeout(dispatch, "error", error.message);

                setIsLoading(false);
            });
    };

    const getGridData = () => {
        return myShortedEventsWithWrongOnHandDate.slice(page.skip, page.take + page.skip);
    };

    const SelectedCell = (props) => {
        const ticketGroupId = props.dataItem.ticketGroupId;
        const selected = props.dataItem.selected;

        return (
            <td className="text-center">
                <Checkbox onChange={(event) => selectedValueChanged(event, ticketGroupId, !selected)} value={selected} />
            </td>
        );
    };

    const SelectedHeaderCell = () => {
        return (
            <div className="text-center">
                <Checkbox onChange={headerCheckboxValueChanged} value={isHeaderCheckboxChecked} />
            </div>
        );
    };

    const TagsCell = (props) => {
        const tags = props.dataItem.tags;

        return (
            <td className={"text-nowrap"}>
                <div className={"tag-list"}>
                    {tags.map((tag, index) => {
                        return <span className={"tag-list-item"}>{tag}</span>;
                    })}
                </div>
            </td>
        );
    };

    const selectedValueChanged = (event, ticketGroupId, selected) => {
        setIsLoading(true);

        setTimeout(() => {
            let myShortedEventsWithWrongOnHandDateCopy = myShortedEventsWithWrongOnHandDate;

            const itemIndex = myShortedEventsWithWrongOnHandDateCopy.findIndex(dataItem =>
                dataItem.ticketGroupId === ticketGroupId
            );

            let isSelectingMultipleItems = false;

            //Shift selection of multiple items            
            if (event.nativeEvent.shiftKey
                && lastSelectedTicketGroupId !== undefined
                && lastSelectedTicketGroupId !== ticketGroupId) {
                const lastSelectedItemIndex = myShortedEventsWithWrongOnHandDateCopy.findIndex(dataItem =>
                    dataItem.ticketGroupId === lastSelectedTicketGroupId
                );

                if (lastSelectedItemIndex >= 0) {
                    isSelectingMultipleItems = true;

                    let lowIndex = -1;
                    let highIndex = -1;

                    if (itemIndex > lastSelectedItemIndex) {
                        lowIndex = lastSelectedItemIndex;
                        highIndex = itemIndex;
                    }
                    else {
                        lowIndex = itemIndex;
                        highIndex = lastSelectedItemIndex;
                    }

                    for (let i = lowIndex; i <= highIndex; i++) {
                        myShortedEventsWithWrongOnHandDateCopy[i].selected = selected;
                    }
                }
            }

            if (isSelectingMultipleItems === false) {
                myShortedEventsWithWrongOnHandDateCopy[itemIndex].selected = selected;
            }

            if (selected === true) {
                setLastSelectedTicketGroupId(ticketGroupId);
            }

            setMyShortedEventsWithWrongOnHandDate(myShortedEventsWithWrongOnHandDateCopy);

            setIsHeaderCheckboxChecked(false);
            setIsLoading(false);
        }, 1);
    };

    const headerCheckboxValueChanged = () => {
        setIsLoading(true);

        setTimeout(() => {
            const checked = !isHeaderCheckboxChecked;
            setIsHeaderCheckboxChecked(checked);

            let myShortedEventsWithWrongOnHandDateCopy = myShortedEventsWithWrongOnHandDate;

            myShortedEventsWithWrongOnHandDateCopy.forEach(dataItem =>
                dataItem.selected = false
            );

            if (checked === true) {
                const gridData = getGridData();

                myShortedEventsWithWrongOnHandDateCopy.forEach(dataItem => {
                    const exists = gridData.includes(dataItem);

                    if (exists) {
                        dataItem.selected = true
                    }
                });
            }

            setMyShortedEventsWithWrongOnHandDate(myShortedEventsWithWrongOnHandDateCopy);

            setLastSelectedTicketGroupId(undefined);

            setIsLoading(false);
        }, 1);
    };

    const getSelectedTicketGroups = () => {
        let ticketGroups = [];

        myShortedEventsWithWrongOnHandDate.forEach(dataItem => {
            if (dataItem.selected === true) {
                ticketGroups.push({
                    ticketGroupId: dataItem.ticketGroupId,
                    eventDate: dataItem.eventDate,
                });
            }
        });

        return ticketGroups;
    }

    const updateSelectedTicketGroupsOnHandDate = () => {
        let ticketGroups = getSelectedTicketGroups();

        if (ticketGroups.length === 0) {
            addNotificationWithTimeout(dispatch, "error", "No ticket groups selected");
            return;
        }

        updateTicketGroupsOnHandDate(ticketGroups);
    };

    useEffect(() => {
        document.title = "My Shorted Events With Wrong On Hand Date";

        getMyShortedEventsWithWrongOnHandDate();
    }, []);

    return (
        <div className="administratorReport">
            {isLoading ? <LoadingPanel /> : <></>}

            {!myShortedEventsWithWrongOnHandDate ? <></> :
                <>
                    <div className="mt-3 mb-3 ms-2 d-flex flex-row">
                        <div>
                            <Button type={"button"} icon="edit" title="Update Selected Ticket Groups On Hand Date" onClick={updateSelectedTicketGroupsOnHandDate}>
                                Update Selected Ticket Groups On Hand Date
                            </Button>
                        </div>
                    </div>

                    <Grid
                        data={getGridData()}
                        resizable={true}
                        skip={page.skip}
                        take={page.take}
                        total={totalEventCount}
                        pageable={true}
                        onPageChange={pageChange}
                        scrollable="none"
                    >
                        <Column cell={SelectedCell} headerCell={SelectedHeaderCell} />
                        <Column field="eventName" title={"Event"} />
                        <Column field="venueName" title={"Venue"} />
                        <Column field="eventDate" title={"Date"} />
                        <Column field="onHandDate" title={"On Hand Date"} />
                        <Column field="isBroadcasted" title={"Broadcasted"} />
                        <Column field="quantity" title={"Quantity"} />
                        <Column field="price" title={"Price"} />
                        <Column field="cost" title={"Cost"} />
                        <Column cell={TagsCell} title={"Tags"} />
                    </Grid>
                </>
            }
        </div>
    );
}